<div *ngIf="isVisible" class="one-loader-overlay">
    <section
        class="one-loader-panel"
        role="dialog"
        aria-modal="true"
        [attr.aria-labelledby]="headingId"
        [attr.aria-describedby]="descriptionId"
        [attr.aria-busy]="active"
    >
        <header class="one-loader-header">
            <div class="one-loader-brand" aria-label="ANAMETA ONE">
                ANAMETA <span>ONE</span>
            </div>
            <div class="one-loader-badge">
                <span
                    *ngIf="!isComplete"
                    class="one-loader-mini-spinner"
                    aria-hidden="true"
                ></span>
                <span>{{ isComplete ? readyText : badgeText }}</span>
            </div>
        </header>

        <div class="one-loader-intro">
            <div class="one-loader-hero-icon">
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path [attr.d]="monitorPath"></path>
                </svg>
            </div>
            <h2 [id]="headingId">{{ isComplete ? readyText : heading }}</h2>
            <p [id]="descriptionId">{{ subtitle }}</p>
        </div>

        <div class="one-loader-progress-area">
            <div class="one-loader-current-title">{{ currentTitle }}</div>
            <div class="one-loader-progress-row">
                <div
                    class="one-loader-progress"
                    role="progressbar"
                    [attr.aria-label]="progressLabel"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    [attr.aria-valuenow]="percentage"
                >
                    <div class="one-loader-progress-fill" [style.width.%]="percentage">
                        <span
                            *ngIf="percentage > 0 && !isComplete"
                            class="one-loader-progress-tip"
                            aria-hidden="true"
                        ></span>
                    </div>
                </div>
                <span class="one-loader-percentage" aria-hidden="true">%{{ percentage }}</span>
            </div>
        </div>

        <ol class="one-loader-steps">
            <li
                *ngFor="let step of steps; let i = index"
                class="one-loader-step"
                [class.step-completed]="GetStepProgress(i) >= 100"
                [class.step-active]="i === currentStep"
                [class.step-waiting]="i > currentStep"
                [attr.aria-current]="i === currentStep ? 'step' : null"
            >
                <div class="one-loader-step-icon">
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path [attr.d]="step.iconPath"></path>
                    </svg>
                </div>
                <div class="one-loader-step-copy">
                    <div class="one-loader-step-title">{{ step.title }}</div>
                    <div class="one-loader-step-caption">{{ GetStepText(i) }}</div>
                    <div
                        class="one-loader-step-progress"
                        role="progressbar"
                        [attr.aria-label]="step.title"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        [attr.aria-valuenow]="GetStepProgress(i)"
                    >
                        <div
                            class="one-loader-step-progress-fill"
                            [style.width.%]="GetStepProgress(i)"
                        ></div>
                    </div>
                </div>
                <div class="one-loader-step-status" aria-hidden="true">
                    <svg
                        *ngIf="GetStepProgress(i) >= 100"
                        class="one-loader-check"
                        viewBox="0 0 24 24"
                    >
                        <circle cx="12" cy="12" r="12"></circle>
                        <path d="m6.5 12 3.5 3.5 7.5-7.5"></path>
                    </svg>
                    <span *ngIf="i === currentStep" class="one-loader-active-spinner"></span>
                    <span *ngIf="i > currentStep" class="one-loader-waiting-circle"></span>
                </div>
            </li>
        </ol>

        <p class="one-loader-sr-only" role="status" aria-live="polite" aria-atomic="true">
            {{ currentTitle }}
        </p>

        <footer class="one-loader-footer">
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M7 10V7a5 5 0 0 1 10 0v3M5 10h14v11H5V10Zm7 4v3"></path>
            </svg>
            <span>Güvenli bağlantı <span class="one-loader-footer-dot">•</span> ANAMETA ONE</span>
        </footer>
    </section>
</div>
